module.exports = __webpack_public_path__ + "img/Logo.4468aefc.png";